export const selectAllFamilies = ({ FamiliesSlice: oState }) => oState?.aFamilies;
export const selectStatusFamilies = ({ FamiliesSlice: oState }) => oState?.bStatus;
export const selectFamilyFamilies = ({ FamiliesSlice: oState }) => oState?.oFamily;
